<template>
  <div class="main-body">
    <div class="header">指挥中心列表</div>
    <div class="out">

      <div class="search2">

        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border >

        <el-table-column prop="name" label="名称" width="200" fixed></el-table-column>

        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>

        <el-table-column prop="listCommandCenterStaffRelDTO" label="后台账号"   width="150">
          <template slot-scope="scope">
            <span v-for="item in scope.row.listCommandCenterStaffRelDTO" v-bind:key="item.commandCenterStaffRelCode">
              <div>{{item.staffName}}</div>
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="address" label="地址" width="250"></el-table-column>

        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            <p>{{scope.row.createTime | timefilters }}</p>
          </template>
        </el-table-column>




        <el-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
<!--            <el-button type="text" size="mini" @click="handleEditStaff(scope.$index, scope.row)">后台账号</el-button>-->

            <el-button type="text" size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码</el-button>

          </template>
        </el-table-column>

      </el-table>

      <div class="page">
            <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination small
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="pageSize"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>



    <EditStaff ref="myEditStaff" v-show="showModalEditStaff" v-on:closeEditStaff="closeEditStaff" v-on:getList="getList"></EditStaff>


    <el-dialog title="密码修改" :visible.sync="pwdDialog" class="dialog" width='400px' center top='30vh'
               :close-on-click-modal='false'>
      <el-input v-model="password" placeholder="请输入登录密码" maxlength="10" minlength="6"
                show-password></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdDialog=false">取 消</el-button>
        <el-button type="primary" @click="editPassword">提交</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import EditStaff from "./EditStaff";

export default {
  name: "Page",
  components:{Add,Edit,EditStaff},

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{
      tableLoading:false,

      loading:false,
      dialogFormVisible:false,

      showModalAdd:false,
      showModalEdit:false,
      showModalEditStaff:false,


      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      status:-1,


      pwdDialog: false,
      password: '',
      commandCenterCode:'',

    }
  },

  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },


    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    handleEditStaff(index, row) {
      this.$refs.myEditStaff.init(row);
      this.showModalEditStaff = !this.showModalEditStaff;
    },
    closeEditStaff:function(){
      this.showModalEditStaff = !this.showModalEditStaff;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CommandCenter/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          status:-1,
        }
      }).then( (response)=> {
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },


    handlePassword(index,row) {
      this.pwdDialog = true;
      this.commandCenterCode = row.commandCenterCode;
      this.password = '';
    },
    editPassword() {

      if (this.password.length < 6) {
        this.$message('密码至少为六位')
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'CommandCenter/EditPassword',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          password: this.password,
          commandCenterCode:this.commandCenterCode,
        }
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          this.$message('修改成功');
          this.pwdDialog = false
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>

